export interface RunwayMlOptions {
  duration: number;
}

export const defaultRunwayMLOptions: RunwayMlOptions = {
  duration: 5,
};
